import * as React from 'react';

function SvgArrowUndo(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M21.481 20.65a.77.77 0 00.519-.727c0-3.514-.706-6.325-2.099-8.354C18.22 9.117 15.564 7.797 12 7.633V3.769a.769.769 0 00-1.3-.556L2.238 11.29a.769.769 0 000 1.112L10.7 20.48a.769.769 0 001.3-.556v-3.835c2.163.065 3.798.416 5.1 1.088 1.406.727 2.425 1.813 3.524 3.222a.77.77 0 00.857.253z" })));
}

export default SvgArrowUndo;
